<template>
    <div>
        
        <div class="container">
            <div class="row justify-content-center">
            <div class="col-lg-7 col-md-7">

                <form @submit.prevent="Salvar(empresa)" class="panel" v-if="form_type!=''">
                <div class="panel-header">
                    Cadastro de empresa de faturamento
                </div>
                <div class="panel-content">

                    <div class="row">
                    <div class="col-lg-4 col-md-4">
                        <label>CPF/CNPJ</label>
                        <the-mask type="text" :mask="['##.###.###/####-##']" @keyup.native="Cnpj(empresa.cnpj)" :masked="false" v-model="empresa.cnpj" class="form-control" />
                    </div>
                    <div class="col-lg-8 col-md-8">
                        <label>Razão social/Nome</label>
                        <input type="text" v-model="empresa.nome" class="form-control">
                    </div>
                    </div>

                    <div class="row">
                    <div class="col-lg-3 col-md-3">
                        <label>CEP</label>
                        <the-mask type="text" :mask="['#####-###']" @keyup.native="Cep(empresa.cep)" v-model="empresa.cep" class="form-control" />
                    </div>
                    <div class="col-lg-5 col-md-5">
                        <label>Logradouro</label>
                        <input type="text" v-model="empresa.logradouro" class="form-control">
                    </div>
                    <div class="col-lg-2 col-md-2">
                        <label>Número</label>
                        <input type="text" v-model="empresa.numero" ref="numero" class="form-control">
                    </div>
                    <div class="col-lg-2 col-md-2">
                        <label>Comp.</label>
                        <input type="text" v-model="empresa.complemento" class="form-control">
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <label>Bairro</label>
                        <input type="text" v-model="empresa.bairro" class="form-control">
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <label>Cidade</label>
                        <input type="text" v-model="empresa.cidade" class="form-control" disabled>
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <label>Estado</label>
                        <input type="text" v-model="empresa.uf" class="form-control" disabled>
                    </div>


                    <div class="col-lg-9 col-md-9">
                        <label>E-mail</label>
                        <input type="text" v-model="empresa.email" class="form-control" >
                    </div>
                    <div class="col-lg-3 col-md-3">
                        <label>Aliquota</label>
                        <money v-model="empresa.aliquota" class="form-control" v-bind="money"></money>
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <label>Token Iugu</label>
                        <input type="text" v-model="empresa.iugu_token" class="form-control" >
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <label>Token API NFE.io</label>
                        <input type="text" v-model="empresa.nfe_token" class="form-control" >
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <label>Token empresa NFE.io</label>
                        <input type="text" v-model="empresa.nfe_token_empresa" class="form-control" >
                    </div>

                    </div>

                    </div>
                    <div class="panel-footer">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <button class="btn btn-secondary" @click="form_type=''" style="margin-right:15px;">Cancelar</button>
                            <input class="btn btn-primary" type="submit" value="Salvar empresa">
                        </div>
                    </div>
                    </div>
                </form>


                <div class="panel" v-if="form_type==''">
                    <div class="panel-header">
                        <div class="row">
                            <div class="col-lg-6 col-md-6" style="padding-top:12px;">
                                Empresas de faturamento
                            </div>
                            <div class="col-lg-6 col-md-6 right">
                                <a href="javascript:void(0)" class="btn btn-success" @click="NovoForm()">Nova empresa</a>
                            </div>
                        </div>
                    </div>
                    <div class="panel-content">


                        <div class="item" v-for="e in empresas" v-bind:key="e.id" @click="Carregar(e)">
                            <p>
                                {{e.cnpj | mask(['##.###.###/####-##']) }}<br>
                                <strong>{{e.nome}}</strong><br>
                            </p>
                        </div>


                    </div>
                </div>
            </div>
            </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import config from '@/config'
import money from 'v-money'
Vue.use(money, {precision: 4})

export default {
    name:"EFaturamento",
    data(){
        return{
            form_type:'',
            money: {
                decimal: '.',
                thousands: '',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            config:config,
            empresa:{
                tipo:"",
                nome:"",
                cnpj:"",
                cep:"",
                logradouro:"",
                numero:"",
                complemento:"",
                bairro:"",
                cidade:"",
                uf:"",
                porte:"",
                decisao:"",
                estados_atuacao:"",
                site:"",
                cnaes:[],
            },
            empresas:{}
        }
    },
    methods:{
        // chama o formulario de criação
        NovoForm(){
            this.form_type='create'
            this.empresa = {}
        },
        // salvar empresa
        Salvar(data){
            if(this.form_type=='create'){
                this.Novo(data)
            }
            if(this.form_type=='update'){
                this.Editar(data)
            }
        },
        // nova empresa
        Novo(data){
            let self = this
            this.$http.post(this.config.API+'efaturamento/criar', data)
            .then(function (response) {
                console.log(response);

                if(response.data.error==true){
                for (let value of Object.values(response.data.message)) {
                    Vue.toasted.show(value, { 
                    theme: "toasted-primary", 
                    position: "top-right", 
                    duration : 5000
                    });
                }
                }else{
                    Vue.toasted.show('Empresa salva com sucesso!', { 
                    theme: "toasted-primary", 
                    position: "top-right", 
                    duration : 5000
                    });
                    self.form_type = ''
                    self.Listar()
                }

            })
            .catch(function (error) {
                console.log(error);
            });

        },
        // editar empresa
        Editar(data){
            let self = this
            this.$http.put(this.config.API+'efaturamento/editar/'+data.id, data)
            .then(function (response) {
                console.log(response);

                if(response.data.error==true){
                for (let value of Object.values(response.data.message)) {
                    Vue.toasted.show(value, { 
                    theme: "toasted-primary", 
                    position: "top-right", 
                    duration : 5000
                    });
                }
                }else{
                    Vue.toasted.show('Empresa salva com sucesso!', { 
                    theme: "toasted-primary", 
                    position: "top-right", 
                    duration : 5000
                    });
                    self.form_type = ''
                    self.Listar()
                    
                }

            })
            .catch(function (error) {
                console.log(error);
            });

        },
        // carregar empresa para edição
        Carregar(empresa){
            this.empresa = empresa
            this.form_type = 'update'
        },
        // listar empresas
        Listar(){
            let self = this
            this.$http.get(this.config.API+'efaturamento')
            .then(function (response) {
                console.log(response)
                self.empresas = response.data
                
            })

        },
        // buscar cep
        Cep(cep){
            if(cep.length>7){
                let config = {
                    headers: {}
                }
                this.$http
                .get("https://viacep.com.br/ws/"+cep+"/json/",config)
                .then((result) => {
                if(result.status==200){
                    this.empresa.logradouro = result.data.logradouro;
                    this.empresa.bairro = result.data.bairro;
                    this.empresa.cidade = result.data.localidade;
                    this.empresa.uf = result.data.uf;
                    this.$refs.numero.focus()
                }
                });
            }
        },
        // buscar cnpj
        Cnpj(cnpj){
            if(cnpj.length>13){
                var base_url = "https://api.cnpja.com.br";
                var config = {
                    headers: {
                        "authorization": "861bc895-a2f4-44bb-81cc-5fa5990b1456-da4690ad-872d-4f6e-ae6e-6810e5f58d29"
                    }
                }
                this.$http
                .get(base_url+"/companies/"+cnpj, config)
                .then((result) => {
                    if(result.status==200){
                        this.empresa.nome = result.data.name
                        this.empresa.logradouro = result.data.address.street;
                        this.empresa.bairro = result.data.address.neighborhood;
                        this.empresa.cidade = result.data.address.city;
                        this.empresa.uf = result.data.address.state;
                        this.empresa.numero = result.data.address.number;
                        this.empresa.complemento = result.data.address.details;
                        this.empresa.cep = result.data.address.zip;
                    }
                });
            }
        }
    },
    beforeMount(){
        this.Listar();
    }
}
</script>